import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { TableCell, TableRow } from '../Shared/Tables';
import { History } from '../../../types';
import moment from 'moment';
import MaterialIcon from '../Shared/Icons/MaterialIcon';

const HistoryRow = styled(TableRow)`
    height: 34px;
    ${p => p.isVisible ? '' : 'visibility: collapse;' }
`;

const IconCell = styled(TableCell)`
    line-height: 1;
`;

const DetailsWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    padding: 5px;
    & > * {
        margin: 5px;
    }
`;

const PhotosWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    flex: 1; /* fill parent width */
    justify-content: space-evenly;
    & > * {
        margin: 5px;
    }
`;

const PackageListWrapper = styled.div`
    /*display: flex;
    flex-direction: column;*/
`;

const PackageContainer = styled.div`

`;

const PhotoImage = styled.img`
    max-height: 400px;
`;

interface HistoryRowProps {
    history: History;
    isVisible?: boolean;
    isConsignmentMode: boolean;
    showPhotos: boolean;
}

const HistoryRowComponent = ({ history, isVisible, isConsignmentMode, showPhotos }: HistoryRowProps) => {
    const [t] = useTranslation();
    
    const [isExpanded, setIsExpanded] = useState(false);
    const isExpandable = isConsignmentMode || (showPhotos && history.HasPhotos);

    const colSpan = 2 + (isConsignmentMode ? 1 : 0) + (showPhotos ? 1 : 0);

    return(
        <>
            <HistoryRow className={isExpandable ? 'interactive' : ''} isVisible={isVisible} onClick={() => setIsExpanded(!isExpanded)}>
                <TableCell>{history.DisplayText}</TableCell>
                <TableCell>{moment(history.When).toDate().toLocaleString()}</TableCell>
                {isConsignmentMode && <TableCell>{history.Items.length}</TableCell>}
                {showPhotos && 
                    <IconCell>
                        <div className={'history-photos'}>{history.HasPhotos ? <MaterialIcon>photo_camera</MaterialIcon> : ''}</div>
                    </IconCell>}
            </HistoryRow>

            {isVisible && isExpandable && isExpanded &&
            <>
                {/* Hidden row to keep odd-row shading consistent */}
                <tr style={{visibility: 'collapse'}} />
                <TableRow>
                    <TableCell colSpan={colSpan}>
                        <DetailsWrapper>
                            {isConsignmentMode &&
                                <PackageListWrapper>
                                    <PackageContainer><strong>{t('history_items')}</strong></PackageContainer>
                                    {history.Items.map(p =>
                                        <PackageContainer key={p}>{p}</PackageContainer>
                                    )}
                                </PackageListWrapper>}

                            {showPhotos && history.HasPhotos &&
                                <PhotosWrapper className={'history-photos'}>
                                    {history.Photos.map(photo =>
                                        <PhotoImage key={photo.Id} src={photo.Url} alt={'image'} />
                                    )}
                                </PhotosWrapper>}
                        </DetailsWrapper>
                    </TableCell>
                </TableRow>
            </>}
        </>
    );
};

export default HistoryRowComponent;